import FoldersService from 'src/services/folders'

export default {
  createFolder (payload) {
    const promise = FoldersService.createNewFolder(payload)

    return promise
  },
  createSubFolder (payload) {
    const promise = FoldersService.createNewSubFolder(payload)

    return promise
  },
  foldersAll () {
    const promise = FoldersService.all()

    promise.then(data => {
      this.folders = data
    })

    return promise
  },
  getFolderById (payload) {
    const promise = FoldersService.byId(payload)

    promise.then(data => {
      this.subFolders = data
    })

    return promise
  },
  getFolderbyApprovedRejected (payload) {
    const promise = FoldersService.folderbyApprovedRejected(payload)

    promise.then(data => {
      this.subFolders = data
    })

    return promise
  },
  getFolderByIdUpload (payload) {
    const promise = FoldersService.folderByIdUpload(payload)

    promise.then(data => {
      this.currentLocations = data
    })

    return promise
  },
  getFolderByIdCurrent (payload) {
    const promise = FoldersService.folderByIdCurrent(payload)

    promise.then(data => {
      this.currentLocations = data
    })

    return promise
  },
  getFolderByIdExpired (payload) {
    const promise = FoldersService.folderByIdExpired(payload)

    promise.then(data => {
      this.currentLocations = data
    })

    return promise
  },
  getFolderByIdProcess (payload) {
    const promise = FoldersService.folderByIdProcess(payload)

    promise.then(data => {
      this.subFolders = data
    })

    return promise
  },
  getFolderByIdExpirationDate (payload) {
    const promise = FoldersService.folderByIdExpirationDate(payload)

    promise.then(data => {
      this.subFolders = data
    })

    return promise
  },
  getFolderByLocationFolder (payload) {
    const promise = FoldersService.byRolLocation(payload)

    promise.then(data => {
      this.subFolders = data
    })

    return promise
  },
  getFolderByLocationFolderUpload (payload) {
    const promise = FoldersService.byRolLocationUpload(payload)

    promise.then(data => {
      this.subFolders = data
    })

    return promise
  },
  getFolderByLocationFolderCurrent (payload) {
    const promise = FoldersService.byRolLocationCurrent(payload)

    promise.then(data => {
      this.subFolders = data
    })

    return promise
  },
  getFolderByLocationFolderExpired (payload) {
    const promise = FoldersService.byRolLocationExpired(payload)

    promise.then(data => {
      this.subFolders = data
    })

    return promise
  },
  getFolderByFolderProcess (payload) {
    const promise = FoldersService.byRolLocationProcess(payload)

    promise.then(data => {
      this.subFolders = data
    })

    return promise
  },
  getFolderByFolderExpirationDate (payload) {
    const promise = FoldersService.byRolLocationExpirationDate(payload)

    promise.then(data => {
      this.subFolders = data
    })

    return promise
  },
  folderByIdUploadResponsible (payload) {
    const promise = FoldersService.folderByIdUploadResponsible(payload)

    promise.then(data => {
      this.currentLocations = data
    })

    return promise
  },
  folderByIdCurrentResponsible (payload) {
    const promise = FoldersService.folderByIdCurrentResponsible(payload)

    promise.then(data => {
      this.currentLocations = data
    })

    return promise
  },
  folderByIdExpiredResponsible (payload) {
    const promise = FoldersService.folderByIdExpiredResponsible(payload)

    promise.then(data => {
      this.currentLocations = data
    })

    return promise
  },
  folderByIdUploadSupervisor (payload) {
    const promise = FoldersService.folderByIdUploadSupervisor(payload)

    promise.then(data => {
      this.currentLocations = data
    })

    return promise
  },
  folderByIdCurrentSupervisor (payload) {
    const promise = FoldersService.folderByIdCurrentSupervisor(payload)

    promise.then(data => {
      this.currentLocations = data
    })

    return promise
  },
  folderByIdExpiredSupervisor (payload) {
    const promise = FoldersService.folderByIdExpiredSupervisor(payload)

    promise.then(data => {
      this.currentLocations = data
    })

    return promise
  },
  folderByIdUploadApprover (payload) {
    const promise = FoldersService.folderByIdUploadApprover(payload)

    promise.then(data => {
      this.currentLocations = data
    })

    return promise
  },
  folderByIdCurrentApprover (payload) {
    const promise = FoldersService.folderByIdCurrentApprover(payload)

    promise.then(data => {
      this.currentLocations = data
    })

    return promise
  },
  folderByIdExpiredApprover (payload) {
    const promise = FoldersService.folderByIdExpiredApprover(payload)

    promise.then(data => {
      this.currentLocations = data
    })

    return promise
  },
  getFolderByRol (payload) {
    const promise = FoldersService.byRol(payload)

    promise.then(data => {
      this.folders = data
    })

    return promise
  },
  deleteFolder (folderId) {
    const promise = FoldersService.delete(folderId)

    return promise
  },
  updateFolder (payload) {
    const promise = FoldersService.update(payload)

    return promise
  },
  getSubFolderName (payload) {
    const promise = FoldersService.subFolderName(payload)

    promise.then(data => {
      this.subFolderName = data
    })

    return promise
  },
  getSubFolderEdit (payload) {
    const promise = FoldersService.subFolderEdit(payload)

    promise.then(data => {
      this.subFolderEdit = data
    })

    return promise
  },
  getSubFolderShow (payload) {
    const promise = FoldersService.subFolderShow(payload)

    promise.then(data => {
      this.subFolderEdit = data
    })

    return promise
  },
  getFolderLocationList (payload) {
    const promise = FoldersService.folderLocationList(payload)

    promise.then(data => {
      this.locationsList = data
    })

    return promise
  },
  updateSubGroup (payload) {
    let promise = FoldersService.updateSubGroup(payload)

    return promise
  },
  getSubFolderList (payload) {
    this.status = 'loading'
    const promise = FoldersService.subFolderList(payload)

    promise.then(data => {
      this.subFolders = data
      this.status = 'success'
    })

    return promise
  },
  resetSubFolder (payload) {
    this.subFolders = payload
  },
  resetSubFolderName ( payload) {
    this.subFolderName = payload
  },
  resetSubFolderEdit (payload) {
    this.subFolderEdit = payload
  },
  resetLocationList (payload) {
    this.locationsList = payload
  },
  getFolder (payload) {
    this.element = payload
  },
  currentFolder (payload) {
    this.selectedFolder = payload
  },
  currentRol (payload) {
    this.selectedRol = payload
  },
  identityRol (payload) {
    this.checkRol = payload
  },
  getSubLocations (payload) {
    const promise = FoldersService.getSubLocations(payload)

    promise.then(data => {
      this.currentLocations = data
    })

    return promise
  },
  getSubLocationsResponsible (payload) {
    const promise = FoldersService.getSubLocationsResponsible(payload)

    promise.then(data => {
      this.currentLocations = data
    })

    return promise
  },
  getSubLocationsSupervisor (payload) {
    const promise = FoldersService.getSubLocationsSupervisor(payload)

    promise.then(data => {
      this.currentLocations = data
    })

    return promise
  },
  getSubLocationsApprover (payload) {
    const promise = FoldersService.getSubLocationsApprover(payload)

    promise.then(data => {
      this.currentLocations = data
    })

    return promise
  }
}
